import { ExceptionGroup, ExceptionMutationAction } from "~/operations";
import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import { cloneElement } from "react";
import { FalsePositiveIcon, WorkaroundIcon } from "~/icons";

export function ExceptionTypeIcon({
  action,
  size,
}: {
  action: ExceptionGroup["action"];
  size?: number;
}) {
  // isRiskAccepted is the default option.  leaving commented for posterity
  //   const isRiskAccepted = action === ExceptionMutationAction.RiskAccepted;
  const isWorkaround = action === ExceptionMutationAction.Workaround;
  const isFalsePositive = action === ExceptionMutationAction.FalsePositive;
  const isDisabled = action === ExceptionMutationAction.Disable;

  //default to risk Accepted
  let eType = {
    label: "Risk accepted",
    icon: <ThumbUpOffAltIcon />,
  };

  if (isWorkaround) {
    eType = {
      label: "workaround",
      icon: <WorkaroundIcon />,
    };
  }

  if (isFalsePositive) {
    eType = {
      label: "False positive",
      icon: <FalsePositiveIcon />,
    };
  }

  if (isDisabled) {
    eType = {
      label: "Disabled",
      icon: <BlockOutlinedIcon />,
    };
  }

  return cloneElement(eType.icon, {
    alt: eType.label,
    sx: { fontSize: size },
  });
}
